import Platform from "pages/space/workspace/detail/platform";
import React from "react";
import style from "css/workspace.module.css";

function Allplace(props) {
  return (
    <>
      <div className={style.fontsize}>
        <Platform type={props.type} />
      </div>
    </>
  );
}

export default Allplace;
